export default function(actionName) {
 return{
   REQUEST: `${actionName}_REQUEST`,
   SUCCESS: `${actionName}_SUCCESS`,
   ERROR: `${actionName}_ERROR`,
 }
};
